import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FaqQuestion } from '../../../common';
import { AccordionViewModel } from './accordions-view-model';

@Component({
  selector: 'osn-shared-accordions',
  templateUrl: './accordions.component.html',
  styleUrls: ['./accordions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('expandAnimation', [
      state('close', style({ height: '0px' })),
      state('open', style({ height: '*' })),
      transition('open <=> close', animate('500ms ease-in-out')),
    ]),
  ],
})
export class AccordionsComponent {
  private _vm: FaqQuestion[];
  public openedAccordionListItems: AccordionViewModel[] = [];
  public trackByFn = (index) => index;

  @Input() public set vm(vm: FaqQuestion[]) {
    this._vm = vm.sort((a, b) => a.order - b.order);
  }
  public get vm(): FaqQuestion[] {
    return this._vm;
  }

  public onAccordionTitleAreaClicked(accordion: AccordionViewModel) {
    if (this.openedAccordionListItems.includes(accordion)) {
      this.openedAccordionListItems = this.openedAccordionListItems.filter((item) => item !== accordion);
    } else {
      this.openedAccordionListItems.push(accordion);
    }
  }
}
